import React, { useEffect, useState } from "react";
import "./styles/EmailModal.css"; // wir nutzen gleich diese CSS-Datei
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { BaseUrl } from "../config";
import { Rating } from "react-simple-star-rating";

export default function ReviewModal({ isOpen, onClose }) {
  const options = [
    { value: "Rund ums Haus", label: "Rund ums Haus" },
    { value: "Rund im Haus", label: "Rund im Haus" },
    { value: "Services", label: "Services" },
    { value: "Rund um den Garten", label: "Rund um den Garten" },
    { value: "Hüpfburg verleih", label: "Hüpfburg verleih" },
  ];

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [rating, setRating] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [option, setOption] = useState(null);

  useEffect(() => {
    if (option === -1) setSelectedOption(null);
    else setSelectedOption(options[option]);
  }, [option]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError("Bitte gib eine gültige E-Mail-Adresse ein.");
      return;
    }
    const data = {
      text,
      option: option.value,
      email,
      name,
      rating,
    };

    try {
      const res = await fetch(`${BaseUrl}/api/review`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!res.ok) throw new Error("Fehler beim Speichern");

      const resJson = await res.json();
      console.log("Review gespeichert:", resJson);
      alert("Review erfolgreich gespeichert!");
    } catch (err) {
      console.error(err);
      alert(err);
    }
    onClose(); // Modal schließen
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Rezession Schreiben</h2>
        <form onSubmit={handleSubmit}>
          <label>
            E-Mail*
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            *Ihre Email wird nicht veröffentlicht, sie dient lediglich zur
            Kontaktierung
          </label>
          <label>
            Name*
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label>
            Leistung*
            <Select
              options={options}
              value={selectedOption}
              onChange={(selected) => setOption(selected)}
              placeholder="Wählen sie ihren Service..."
            />
          </label>
          <label>
            Rating
            <Rating onClick={(rating) => setRating(rating)} allowFraction />
          </label>
          <label>
            Text
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              rows={4}
            />
          </label>
          {error && <p className="error">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={onClose}>
              Abbrechen
            </button>
            <button type="submit">Senden</button>
          </div>
        </form>
      </div>
    </div>
  );
}
